import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

export default function AdminAccess({ children }) {
    const { currentUser, isAdmin, isAuthLoading } = useUser();
    
    if (isAuthLoading) {
        return <div className="text-center p-4">Loading...</div>;
    }
    
    if (!currentUser || !isAdmin) {
        return <Navigate to="/" replace />;
    }
    
    return children;
}